import './App.css';
import Maze from './components/Main.jsx';

function App() {
  return (
    <div className="App">
      <Maze width={10} height={10}/>
    </div>
  );
}

export default App;
